import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './i18n.js';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';

const {
  REACT_APP_AUTH0_DOMAIN,
  REACT_APP_AUTH0_CLIENT_ID,
  PUBLIC_URL,
  REACT_APP_AUTH0_AUDIENCE,
} = process.env;

ReactDOM.render(
  <Auth0Provider
    domain={REACT_APP_AUTH0_DOMAIN || 'lifenome.auth0.com'}
    clientId={REACT_APP_AUTH0_CLIENT_ID || 'b0l74etg7qp4Obz4WORzNVxMKZAEuzz7'}
    redirectUri={`${window.location.origin}${PUBLIC_URL}`}
    audience={REACT_APP_AUTH0_AUDIENCE}
    useRefreshTokens={true}
    cacheLocation="localstorage"
  >
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Auth0Provider>,

  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
